export enum PrintMode {
  EMAIL = 'EMAIL',
  DIRECT= 'DIRECT',
  NONE = 'NONE',
}

export class LocalLocationOptionConfiguration {

  public id: string;
  public buttonCaption: string;
  public apiUsername: string;
  public apiPassword: string;
  public usedOnMobile: boolean;
  public printerEmail: string;
  public printMode: PrintMode;

  static fromDto(data: any): LocalLocationOptionConfiguration {
    const option = new LocalLocationOptionConfiguration();

    if (!data) {
      return null;
    }

    option.id            = data.id;
    option.buttonCaption = data.button_caption;
    option.apiPassword   = data.api_password;
    option.apiUsername   = data.api_username;
    option.usedOnMobile  = data.used_on_mobile;
    option.printMode     = data.print_mode;
    option.printerEmail  = data.printer_email;

    return option;
  }

  static toDto(c: LocalLocationOptionConfiguration): any {
    if (!c) {
      return null;
    }

    return {
      id: c.id,
      button_caption: c.buttonCaption,
      api_password: c.apiPassword,
      api_username: c.apiUsername,
      used_on_mobile: c.usedOnMobile,
      print_mode: c.printMode,
      printer_email: c.printerEmail,
    };
  }
}
